import { ReactNode, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import useAuth from '@/hooks/useAuth'

type GuardProps = {
  children: ReactNode
}

const GuestGuard = (props: GuardProps) => {
  const { children } = props
  const { isLoggedIn, isLoading } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (!isLoading && isLoggedIn) {
      navigate('/home', { replace: true })
    }
  }, [isLoading, isLoggedIn, navigate])

  return children
}

export default GuestGuard
